import type { App } from "vue";

import type { RouteRecordRaw } from "vue-router";
import VueMatomo from "vue-matomo";
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";

import { beforeEach } from "./config";

import WebRoutes from "./modules/webRoutes";

import ClientRoutes from "./modules/clientRoutes";

import LoginRoutes from "./modules/Login";

import templateRoutes from "./modules/templateRoutes";

const getRoutes = () => {
  if (process.env.IS_ELECTRON) return [...ClientRoutes, ...templateRoutes];
  return [...WebRoutes, ...templateRoutes];
};
const router = createRouter({
  history: process.env.IS_ELECTRON
    ? createWebHashHistory()
    : createWebHistory(),
  routes: [...getRoutes(), ...LoginRoutes],
  strict: true,
});

beforeEach(router);
const isPro = process.env.VUE_APP_ENV === "production";
const isElectron = process.env.IS_ELECTRON;
function getSiteId() {
  if (isElectron) {
    // 客户端
    return isPro ? 4 : 5; // 生产环境：2，测试环境：1
  } else {
    // 网页
    return isPro ? 2 : 3; // 生产环境：4，测试环境：3
  }
}
export function registerRouter(app: App) {
  app.use(router);
  app.use(VueMatomo, {
    host: "https://analysis.dianshudata.com/",
    siteId: getSiteId(),
    router: router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    disableCookies: false,
    requireCookieConsent: false,
  });
}

export function useRouter() {
  return router;
}

// 根据权限动态添加路由
export function addRoutes(routes: RouteRecordRaw[]) {
  routes.forEach((i) => router.addRoute("Root", i));
}
